<template>
  <div v-if="nextRecord || prevRecord" class="flex items-center justify-end gap-1">
    <button
      :disabled="!prevRecord"
      class="inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900"
      :class="{ 'cursor-not-allowed opacity-20': !prevRecord }"
      data-track="clicked-candidate-arrow-navigation"
      @click="viewPrevious"
    >
      <vue-feather type="chevron-left" class="h-4" />
    </button>
    <button
      :disabled="!nextRecord"
      class="inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900"
      :class="{ 'cursor-not-allowed opacity-20': !nextRecord }"
      data-track="clicked-candidate-arrow-navigation"
      @click="viewNext"
    >
      <vue-feather type="chevron-right" class="h-4" />
    </button>
  </div>
</template>

<script>
import { useContactListContextStore } from '@/stores/contactListContext.ts';
export default {
  setup() {
    const contactListContextStore = useContactListContextStore();
    return {
      contactListContextStore,
    };
  },
  computed: {
    filteredContacts() {
      return this.contactListContextStore.contactListContext.records;
    },
    currentIndex() {
      return this.contactListContextStore.contactListContext.currentIndex;
    },
    prevRecord() {
      return this.filteredContacts[this.currentIndex - 1];
    },
    nextRecord() {
      return this.filteredContacts[this.currentIndex + 1];
    },
  },
  methods: {
    async viewPrevious() {
      const self = this;

      const id = self.prevRecord.id;

      this.contactListContextStore.setContactListContext({
        records: self.filteredContacts,
        currentIndex: self.currentIndex - 1,
        label: null,
      });
      await this.$router.push({ name: 'CandidateDetail', params: { id } });
      this.$emit('update');
    },
    async viewNext() {
      const self = this;

      const id = self.nextRecord.id;

      this.contactListContextStore.setContactListContext({
        records: self.filteredContacts,
        currentIndex: self.currentIndex + 1,
        label: null,
      });
      await this.$router.push({ name: 'CandidateDetail', params: { id } });
      this.$emit('update');
    },
  },
};
</script>
